import { string, number, object, array, shape, bool } from 'prop-types';

// Import components
import { AvailableIndication } from 'components/elements';
import ItemMetadata from 'components/views/vod/components/ItemDetails/ItemMetadata';
import ItemLink from './ItemLink';

// import styles
import { ContinueWatchingData, Strap } from 'components/views/vod/components/sliders/styles/progressBar';
import { Item } from './styles';

// Import utilities
import { useProductAvailability } from 'components/utilities';
import useSliderItemLogic from './useSliderItemLogic';

// Import helpers
import { sendChannelEvent } from 'helpers/tracking';

// Import variables
import { PRODUCTS_TYPES } from 'helpers/variables';

const { CHANNEL } = PRODUCTS_TYPES;

export function SliderItem(props) {
	const { data, width, height, itemWithLink = true } = props;
	const isAvailable = useProductAvailability(data);

	const { itemDetailsData, isContinueWatchingSection, isCollectionPage, backgroundImage, linkParams, continuePercent, backgroundSize } =
		useSliderItemLogic(props);

	const { country, rating, title, year, genres: itemDetailsGenres } = itemDetailsData;

	const { genres, type } = data;

	const handleGtmEvent = () => {
		if (type === CHANNEL) {
			sendChannelEvent({ url: linkParams?.pathname, genres, item_name: title });
		}
	};

	return (
		<Item image={backgroundImage} width={width} height={height} backgroundSize={backgroundSize} itemWithLink={itemWithLink}>
			{itemWithLink && <ItemLink to={linkParams} gtmEvent={handleGtmEvent} />}
			{isAvailable && !isCollectionPage && <AvailableIndication />}
			{isContinueWatchingSection && isAvailable && !!continuePercent && (
				<ContinueWatchingData>
					<Strap percent={continuePercent} />
				</ContinueWatchingData>
			)}

			<ItemMetadata title={title} genres={itemDetailsGenres} rating={rating} country={country} year={year} />
		</Item>
	);
}

SliderItem.propTypes = {
	sectionLabel: string.isRequired,
	data: shape({
		uuid: string.isRequired,
		images: object,
		subtype: string.isRequired,
		context: object,
		title: string,
		year: number,
		genres: array,
		rating: number,
		country: string
	}),
	width: number.isRequired,
	height: number.isRequired,
	sliderId: string,
	itemWithLink: bool
};
